import React, {Fragment} from "react";
import {scroller} from "react-scroll";
import cn from "classnames";
import type {Property} from "csstype";

import type {ITab} from "../types/ITab";
import type {TabsAllowedValueTypes} from "../types/TabsAllowedValueTypes";
import type {TabsSize} from "../types/TabsSize";
import type {TabsVariant} from "../types/TabsVariant";
import {Title} from "./Title";

import * as styles from "./Tabs.module.css";

export type TabsProps<ValueType extends TabsAllowedValueTypes> = {
    activeAriaCurrent?: "page";
    className?: string;
    customRenderer?: (tab: ITab<ValueType>, titleElement: React.ReactNode, index: number) => React.ReactNode;
    fullWidth?: boolean;
    nativeLinkNavigation?: boolean;
    onChange?: (value: ValueType) => void;
    size?: TabsSize;
    tabs: ITab<ValueType>[];
    titleClassName?: string;
    titlesMaxWidth?: Property.MaxWidth;
    value?: ValueType;
    variant?: TabsVariant;
};

export const Tabs = <ValueType extends TabsAllowedValueTypes>(props: TabsProps<ValueType>) => {
    const {
        activeAriaCurrent,
        className,
        customRenderer,
        fullWidth,
        nativeLinkNavigation,
        onChange,
        size = "default",
        tabs,
        titleClassName,
        titlesMaxWidth,
        value,
        variant = "default"
    } = props;

    const onClick = (tab: ITab<ValueType>) => {
        onChange?.(tab.value);

        if (tab.scrollId) {
            scroller.scrollTo(tab.scrollId, {offset: tab.scrollOffset ?? 0, smooth: true});
        }

        if (tab.scrollRef?.current) {
            tab.scrollRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
        }
    };

    const tilesClasses = cn(styles.tiles, variant === "contained" ? styles.tilesContained : styles.tilesDefault, fullWidth && styles.tilesFullWidth);

    return (
        <div className={cn(styles.tabs, className)}>
            <div className={cn(styles.titles, fullWidth && styles.titlesFullWidth)} style={titlesMaxWidth ? {maxWidth: titlesMaxWidth} : undefined}>
                <div className={tilesClasses} role="tablist">
                    {tabs.map((tab, index) => {
                        const active = typeof value !== "undefined" ? value === tab.value : false;

                        const titleElement = (
                            <Title
                                key={String(tab.value ?? index)}
                                active={active}
                                activeAriaCurrent={activeAriaCurrent}
                                className={titleClassName}
                                dataTestId={tab.dataTestId}
                                fullWidth={fullWidth}
                                gtmClick={tab.gtmClick}
                                href={tab.href}
                                nativeLinkNavigation={nativeLinkNavigation}
                                onClick={() => onClick(tab)}
                                size={size}
                                variant={variant}
                            >
                                {tab.title}
                            </Title>
                        );

                        return customRenderer ? customRenderer(tab, titleElement, index) : titleElement;
                    })}
                </div>
            </div>

            {tabs.map((tab, index) => {
                return value === tab.value ? <Fragment key={`tc${String(tab.value ?? index)}`}>{tab.content}</Fragment> : null;
            })}
        </div>
    );
};
import React, {Fragment} from "react";
import {scroller} from "react-scroll";
import cn from "classnames";
import type {Property} from "csstype";

import type {ITab} from "../types/ITab";
import type {TabsAllowedValueTypes} from "../types/TabsAllowedValueTypes";
import type {TabsSize} from "../types/TabsSize";
import type {TabsVariant} from "../types/TabsVariant";
import {Title} from "./Title";

import * as styles from "./Tabs.module.css";

export type TabsProps<ValueType extends TabsAllowedValueTypes> = {
    activeAriaCurrent?: "page";
    className?: string;
    customRenderer?: (tab: ITab<ValueType>, titleElement: React.ReactNode, index: number) => React.ReactNode;
    fullWidth?: boolean;
    nativeLinkNavigation?: boolean;
    onChange?: (value: ValueType) => void;
    size?: TabsSize;
    tabs: ITab<ValueType>[];
    titleClassName?: string;
    titlesMaxWidth?: Property.MaxWidth;
    value?: ValueType;
    variant?: TabsVariant;
};

export const Tabs = <ValueType extends TabsAllowedValueTypes>(props: TabsProps<ValueType>) => {
    const {
        activeAriaCurrent,
        className,
        customRenderer,
        fullWidth,
        nativeLinkNavigation,
        onChange,
        size = "default",
        tabs,
        titleClassName,
        titlesMaxWidth,
        value,
        variant = "default"
    } = props;

    const onClick = (tab: ITab<ValueType>) => {
        onChange?.(tab.value);

        if (tab.scrollId) {
            scroller.scrollTo(tab.scrollId, {offset: tab.scrollOffset ?? 0, smooth: true});
        }

        if (tab.scrollRef?.current) {
            tab.scrollRef.current.scrollIntoView({behavior: "smooth", block: "start", inline: "center"});
        }
    };

    const tilesClasses = cn(styles.tiles, variant === "contained" ? styles.tilesContained : styles.tilesDefault, fullWidth && styles.tilesFullWidth);

    return (
        <div className={cn(styles.tabs, className)}>
            <div className={cn(styles.titles, fullWidth && styles.titlesFullWidth)} style={titlesMaxWidth ? {maxWidth: titlesMaxWidth} : undefined}>
                <div className={tilesClasses} role="tablist">
                    {tabs.map((tab, index) => {
                        const active = typeof value !== "undefined" ? value === tab.value : false;

                        const titleElement = (
                            <Title
                                key={String(tab.value ?? index)}
                                active={active}
                                activeAriaCurrent={activeAriaCurrent}
                                className={titleClassName}
                                dataTestId={tab.dataTestId}
                                fullWidth={fullWidth}
                                gtmClick={tab.gtmClick}
                                href={tab.href}
                                nativeLinkNavigation={nativeLinkNavigation}
                                onClick={() => onClick(tab)}
                                size={size}
                                variant={variant}
                            >
                                {tab.title}
                            </Title>
                        );

                        return customRenderer ? customRenderer(tab, titleElement, index) : titleElement;
                    })}
                </div>
            </div>

            {tabs.map((tab, index) => {
                return value === tab.value ? <Fragment key={`tc${String(tab.value ?? index)}`}>{tab.content}</Fragment> : null;
            })}
        </div>
    );
};
